const _temp0 = require("./main.webp");
const _temp1 = require("./vine_1.webp");
const _temp2 = require("./vine_3.webp");
module.exports = {
  "main": _temp0,
  "vine_1": _temp1,
  "vine_3": _temp2
}